import { APP_COLORS } from "../enums";

declare module "@mui/material/styles" {
  interface Palette {
    custom: Record<string, string>;
  }
  interface PaletteOptions {
    custom?: Record<string, string>;
  }
}


const STANDARD_PALETTE_COLORS = new Set([
  "primary",
  "primaryLight",
  "primaryDark",
  "secondary",
  "secondaryLight",
  "secondaryDark",
  "error",
  "errorLight",
  "errorDark",
  "success",
  "successLight",
  "successDark",
  "yellow",
  "yellowLight",
  "yellowDark",
  "info",
  "infoLight",
  "infoDark",
  "text",
  "textSecondary",
]);


const buildCustomColors = (): Record<string, string> => {
  const custom: Record<string, string> = {};
  
  Object.entries(APP_COLORS).forEach(([key, value]) => {
    
    if (isNaN(Number(key)) && !STANDARD_PALETTE_COLORS.has(key)) {
      custom[key] = value as string;
    }
  });
  
  return custom;
};

const customColors = {
  palette: {
    
    text: {
      primary: APP_COLORS.text,
      secondary: APP_COLORS.textSecondary,
    },
    primary: {
      main: APP_COLORS.primary,
      light: APP_COLORS.primaryLight,
      dark: APP_COLORS.primaryDark,
    },
    secondary: {
      main: APP_COLORS.secondary,
      light: APP_COLORS.secondaryLight,
      dark: APP_COLORS.secondaryDark,
    },
    error: {
      main: APP_COLORS.error,
      light: APP_COLORS.errorLight,
      dark: APP_COLORS.errorDark,
    },
    success: {
      main: APP_COLORS.success,
      light: APP_COLORS.successLight,
      dark: APP_COLORS.successDark,
    },
    warning: {
      main: APP_COLORS.yellow,
      light: APP_COLORS.yellowLight,
      dark: APP_COLORS.yellowDark,
    },
    info: {
      main: APP_COLORS.info,
      light: APP_COLORS.infoLight,
      dark: APP_COLORS.infoDark,
    },
    
    custom: buildCustomColors(),
  },
};

export { customColors };
